/* eslint no-unused-vars: 0 */
import ajax from "../utils/ajax";

export const ajaxContactUs = (payload) => {
  return ajax.post("/api/contact/", payload);
};
